import axios from "axios";

export async function getWeather(city: string) {
    try {
        const apiKey = process.env.REACT_APP_OPENWEATHER_API_KEY;
        if (!apiKey) {
            throw new Error('API key for OpenWeatherMap is not defined');
        }
        const res = await axios.get(
            `https://api.openweathermap.org/data/2.5/forecast?q=${city}&units=metric&lang=fr&appid=${apiKey}`
        );
        return res.data;
    } catch (error: any) {
        console.error('Error fetching weather data:', error.response);
        return false;
    }
}
